import { useRichTextEditorContext } from '../hooks/useRichTextEditorContext';
import { BubbleMenu } from '@tiptap/react';
import { InlineToolbarActiveLink } from './InlineToolbarActiveLink';

export const InlineToolbar = () => {
  const { editor } = useRichTextEditorContext();

  if (!editor) return null;

  return (
    <div>
      <BubbleMenu
        editor={editor}
        shouldShow={({ editor }) => {
          return editor.isActive('link');
        }}
        tippyOptions={{
          popperOptions: {
            strategy: 'fixed',
          },
        }}
        className="z-10 max-w-[calc(100dvw-theme(space.x1))] rounded-x1 bg-surface-3 shadow-md"
      >
        <InlineToolbarActiveLink />
      </BubbleMenu>
    </div>
  );
};
